/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {
  getMarginBottomClass,
  marginBottomLevels,
} from '../../utils/marginBottom';
import detectBrowser from '../../utils/detectBrowser';

import Masthead from '../Masthead';
import Footer from '../Footer';

import styles from './page.css';

// No support for <main> element on IE11
const componentDefault = detectBrowser.ie11 ? 'div' : 'main';

const Page = ({
  component: Component = componentDefault,
  children,
  headerSlot,
  footerSlot,
  marginBottom,
}) => (
  <div className={styles.Page}>
    <div className={styles.wrapper}>
      {headerSlot || <Masthead />}
      <Component
        className={cn(styles.main, {
          [styles['main-padding']]: marginBottom === null,
          [getMarginBottomClass(marginBottom)]: marginBottom !== null,
        })}
        role="main"
      >
        {children}
      </Component>
      {footerSlot || <Footer />}
    </div>
  </div>
);

Page.displayName = 'Page';

Page.defaultProps = {
  marginBottom: null,
};

Page.propTypes = {
  headerSlot: PropTypes.node,
  footerSlot: PropTypes.node,
  children: PropTypes.node,
  component: PropTypes.string,
  /**
   * Sets margin bottom of the content part. Setting this value turns off fixed padding-bottom value.s
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),
};

export { Page };

export default Page;
